<a mat-list-item (click)="toggle()" style="width: fit-content;">
        <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}"
            class="submenu">
            <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Tabelas de Referência">
                <mat-icon>table_chart</mat-icon>
                <span *ngIf="menuPrincipalService.expandido" class="nav-caption">Tabelas de Referência</span>
            </div>
            <div fxLayout="row" fxLayoutAlign="start stretch">
                <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
            </div>
        </div>
    </a>

    <mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">

        <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">

            <!-- PLANOS DE CONTAS-->
            <div style="padding-left: 15px">
                <sub-menu *ngIf="verificaAcesso(getModulos().PLANOS_CONTAS_CONTABEIS)" icone="toc" titulo="Planos de Contas" rota="planoscontascontabeis" toolTip="Planos de Contas Contábeis"></sub-menu>
            </div>
        
            <!-- CONTAS BANCÁRIAS-->
            <div style="padding-left: 15px">
                <sub-menu *ngIf="verificaAcesso(getModulos().CONTAS_BANCARIA)" icone="local_atm" titulo="Contas Bancárias" rota="contasbancarias" toolTip="Contas Bancárias"></sub-menu>
            </div>
        
        </div>
    </mat-nav-list>
